import { Outlet, useNavigate } from "react-router-dom";
import "./styles/Portal.css"
import { createContext, useEffect, useState } from "react";
import { getAuthUser } from "./aws/Authentication";
import { Auth } from "aws-amplify";

const PortalContext = createContext();

function Portal() {
  const navigate = useNavigate();
  const [user, setUser] = useState();
  const [devices, setDevices] = useState();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [options, setOptions] = useState();
  const [optionsCampo, setOptionsCampo] = useState();
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectedCampos, setSelectedCampos] = useState([]);
  const [eventoEscolhido, setEventoEscolhido] = useState();
  const [ campoEscolhido, setCampoEscolhido ] = useState();
  const [shpData, setShpData] = useState(null);
  const [shxData, setShxData] = useState(null);
  const [dbfData, setDbfData] = useState(null);
  const [ identityId, setIdentityId ] = useState();
  const [shapefile, setShapefile] = useState();

  async function RecuperaIdentityId() {
      const creds = await Auth.currentCredentials();
      console.log("Identity ID:", creds.identityId);
      setIdentityId(creds.identityId);
  }

  useEffect(() => {
    getAuthUser().then(resp => {
      if (resp == null) {
        navigate("/portal/signin");
        return;
      } 
      setUser(resp);
      console.log("Diz que foi pra /portal/home")
      navigate("/portal/home");
      RecuperaIdentityId();
      console.log("OK usuario ", resp.attributes.email, " logado");
      
    }).then(data => {
      console.log("data = ", data);
    });
  }, [navigate]);
  /* const setarDevices = (devs) => {
    setDevices(devs);
    console.log("Devices setados. devices = ", devices);
  } */
  return (
    <PortalContext.Provider value={
      {
        user,
        setUser,
        devices,
        setDevices,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        eventoEscolhido,
        setEventoEscolhido,
        campoEscolhido,
        setCampoEscolhido,
        options, 
        setOptions,
        optionsCampo,
        setOptionsCampo,
        selectedDevices, 
        setSelectedDevices,
        selectedCampos, 
        setSelectedCampos,
        shpData, 
        setShpData,
        dbfData, 
        setDbfData,
        shxData, 
        setShxData,
        identityId,
        shapefile,
        setShapefile,
      }
    }>
      <div className="portal">
        <Outlet/>
      </div>
    </PortalContext.Provider>
  );
}

export { Portal, PortalContext };
